import { render, staticRenderFns } from "./ProjectMessages.vue?vue&type=template&id=4495573a&scoped=true&"
import script from "./ProjectMessages.vue?vue&type=script&lang=js&"
export * from "./ProjectMessages.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMessages.vue?vue&type=style&index=0&id=4495573a&lang=scss&scoped=true&"
import style1 from "./ProjectMessages.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4495573a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
